export default {"src":"/_next/static/media/close.aba5a33d.svg","height":14,"width":14};